// extracted by mini-css-extract-plugin
module.exports = {"main-component":"eventImage_main-component__1c1xv"};